import { makeRequest } from 'utils/requestLogger';

export default (discussionID) =>
  makeRequest('delete', `/api/live_discussions/${discussionID}`);



// WEBPACK FOOTER //
// ./src/app/services/liveDiscussion/deleteDiscussion.js